import {
    CromiRentDirectionsSlugAsConst,
    DirectionsSlugAsConst,
    type TCromiRentDirectionSlug,
    type TDirectionSlug,
} from '~/types/global.types'

import type { ICatalogCategory } from '~/components/pages/catalog/catalog-category/catalog-category.types'

export default defineNuxtRouteMiddleware(async (to) => {
    if (!to.matched.length) {
        throw createError({
            statusCode: 404,
            message: 'Страница не найдена',
        })
    } else if (
        ['direction', 'direction-subcategory'].includes(
            String(to.matched[0].name)
        )
    ) {
        if (
            ![
                ...DirectionsSlugAsConst,
                ...CromiRentDirectionsSlugAsConst,
            ].includes(
                String(to.params.direction) as
                    | TDirectionSlug
                    | TCromiRentDirectionSlug
            )
        ) {
            throw createError({
                statusCode: 404,
                message: 'Страница не найдена',
            })
        }
    }

    if (to.path === '/catalog' && to.query.category) {
        const nuxtApp = useNuxtApp()

        const { data: categories } = await useApiFetch<
            Page<ICatalogCategory[]>
        >(`/v1/catalogues`, {
            getCachedData(key) {
                return nuxtApp.payload?.data?.[key]
            },
        })

        if (
            !categories?.value?.data?.find(
                (category) => category.slug === to.query.category
            )
        ) {
            return navigateTo('/catalog')
        }
    } else if (to.path === '/portfolio' && to.query.region) {
        const regions = [
            'ural',
            'south',
            'privolzsky',
            'north-west',
            'east',
            'central',
            'sng',
        ]

        if (!regions.includes(String(to.query.region))) {
            return navigateTo(`/portfolio`)
        }
    }
})
